import { render, staticRenderFns } from "./ContractLocationsSummary.vue?vue&type=template&id=6bbc8521"
import script from "./ContractLocationsSummary.vue?vue&type=script&lang=js"
export * from "./ContractLocationsSummary.vue?vue&type=script&lang=js"
import style0 from "./ContractLocationsSummary.vue?vue&type=style&index=0&id=6bbc8521&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports